import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Incomplete16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_355)'>
      <path
        d='M8 1.75C11.4518 1.75 14.25 4.54822 14.25 8C14.25 11.4518 11.4518 14.25 8 14.25C7.72265 14.25 7.44989 14.232 7.18274 14.1971L6.98873 15.6845C7.32004 15.7277 7.65761 15.75 8 15.75C12.2802 15.75 15.75 12.2802 15.75 8C15.75 3.71979 12.2802 0.25 8 0.25C7.65761 0.25 7.32004 0.27225 6.98873 0.315466L7.18274 1.80287C7.44989 1.76802 7.72265 1.75 8 1.75Z'
        fill='currentColor'
      />
      <path
        d='M3.28152 14.1485C3.81457 14.5581 4.40273 14.9002 5.0332 15.1616L5.60778 13.776C5.10007 13.5655 4.62582 13.2898 4.19551 12.9591L3.28152 14.1485Z'
        fill='currentColor'
      />
      <path
        d='M5.03319 0.838369C4.40273 1.09981 3.81457 1.44188 3.28152 1.85151L4.19551 3.04089C4.62582 2.71022 5.10007 2.43449 5.60778 2.22396L5.03319 0.838369Z'
        fill='currentColor'
      />
      <path
        d='M0.838369 10.9668C1.09981 11.5973 1.44188 12.1854 1.85151 12.7185L3.04089 11.8045C2.71022 11.3742 2.43449 10.8999 2.22396 10.3922L0.838369 10.9668Z'
        fill='currentColor'
      />
      <path
        d='M1.85151 3.28152C1.44188 3.81457 1.09981 4.40273 0.838369 5.0332L2.22396 5.60778C2.43449 5.10007 2.71022 4.62582 3.04089 4.19551L1.85151 3.28152Z'
        fill='currentColor'
      />
      <path
        d='M0.315466 6.98873C0.229032 7.65135 0.229033 8.34865 0.315466 9.01127L1.80287 8.81726C1.73317 8.28296 1.73317 7.71704 1.80287 7.18274L0.315466 6.98873Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_355'>
        <rect
          width='16'
          height='16'
          fill='white'
          transform='matrix(0 1 -1 0 16 0)'
        />
      </clipPath>
    </defs>
  </Svg>
);

Incomplete16.displayName = 'Incomplete16';
export default Incomplete16;
